import { render, staticRenderFns } from "./RecordingConsentModal.vue?vue&type=template&id=8a76786a&scoped=true&"
import script from "./RecordingConsentModal.vue?vue&type=script&lang=js&"
export * from "./RecordingConsentModal.vue?vue&type=script&lang=js&"
import style0 from "./RecordingConsentModal.vue?vue&type=style&index=0&id=8a76786a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a76786a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a76786a')) {
      api.createRecord('8a76786a', component.options)
    } else {
      api.reload('8a76786a', component.options)
    }
    module.hot.accept("./RecordingConsentModal.vue?vue&type=template&id=8a76786a&scoped=true&", function () {
      api.rerender('8a76786a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/RecordingConsentModal.vue"
export default component.exports